import { emptySplitApi } from './index'

export const userNotificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserNotificationsFullReadList: builder.mutation({
      query: () => ({
        url: `api/v1/auth-service/user-notifications/full`,
        method: "GET"
      }),
    }),
    getUserNotificationsList: builder.mutation({
      query: (pageNumber) => ({
        url: `api/v1/auth-service/user-notifications/${pageNumber}`,
        method: "GET"
      }),
    }),
    readUserNotification: builder.mutation({
        query: (notificationId) => ({
          url: `api/v1/auth-service/user-notifications/read/${notificationId}`,
          method: "GET"
        }),
    }),
    updateAllNotificationsToRead: builder.mutation({
        query: () => ({
          url: `api/v1/auth-service/user-notifications/read-all`,
          method: "POST"
        }),
    }),
    getAmountOfNotifications: builder.mutation({
        query: () => ({
          url: `api/v1/auth-service/user-notifications/amount`,
          method: "GET"
        }),
    }),
    getNotificationDocuments: builder.mutation({
      query: (id) => `api/v1/auth-service/user-notifications/announcement-documents/${id}`,
    }),
  }),
  overrideExisting: false,
});

export const { 
    useGetUserNotificationsFullReadListMutation,
    useGetUserNotificationsListMutation,
    useReadUserNotificationMutation,
    useUpdateAllNotificationsToReadMutation,
    useGetAmountOfNotificationsMutation,
    useGetNotificationDocumentsMutation,
} = userNotificationApi;
